import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./SesssionExpiredModal.module.css";
import { Modal, Button } from "@sainsburys-tech/fable";

const SessionExpiredModal: React.FC<{ show: boolean }> = ({ show }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);

  if (
    !show ||
    window.location.pathname === "/" ||
    window.location.pathname === "/logout" ||
    localStorage.getItem("accessToken") === null
  ) {
    return null;
  }
  const handleReauthenticate = () => {
    setIsOpen(false);
    localStorage.removeItem("isSessionExpired");
    localStorage.clear();
    navigate("/");
  };

  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        onClose={() => handleReauthenticate}
        layout="default"
        header={{
          isDismissible: true
        }}
      >
        <div className="text-center">
          <h3>Your Session is Expired</h3>
          <p> Please reauthenticate yourself...</p>
          <Button onClick={handleReauthenticate}>Login</Button>
        </div>
      </Modal>
      )
    </div>
  );
};

export default SessionExpiredModal;
